export const EMAIL_ACTION = {
	SUBSCRIBE:     'EMAIL_SUBSCRIBE',
}
